import { render, staticRenderFns } from "./header-carousel.vue?vue&type=template&id=2dc2ab71&scoped=true&"
import script from "./header-carousel.vue?vue&type=script&lang=js&"
export * from "./header-carousel.vue?vue&type=script&lang=js&"
import style0 from "./header-carousel.vue?vue&type=style&index=0&id=2dc2ab71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2ab71",
  null
  
)

export default component.exports